/**
 * @function debounce
 * @description Create a new function, which when called will delay the invocation of <code>func</code> until <code>wait</code> milliseconds after it was last called.
 * @param {function} func Callback function that will be triggered
 * @param {number} wait The wait time before triggering
 * @returns {function} The function to call on your onChange
 * @example
 * debouncedUpdateRole = debounce((inputString, organizationId, resolve) => {
 *     resolve(
 *         this.props.RolesContext.getOrganizationRoles(organizationId)
 *             .then(data => {
 *                 return data.filter(o => o.active === '1').filter(o => o.title.includes(inputString)).map(option => ({
 *                     label: option.title,
 *                     value: option.role_id,
 *                 }))
 *             })
 *             .catch(error => {
 *                 console.error(error.message);
 *                 if(!AxiosIsCancelled(error.message))
 *                      this.setState(() => ({loading: 'error'}))
 *                 return [];
 *             })
 *     )
 * }, 500);
 *
 * // This function is called on an onChange
 * updateRoleSelect = (inputString, organizationId) => {
 *     return new Promise(resolve => {
 *         this.debouncedUpdateRole(inputString, organizationId, resolve)
 *     });
 * }
 * @copyright Spordle
 */
 export function debounce<F extends Function>(func: F, wait: number): F {
    let timeoutID: number;

    if (!Number.isInteger(wait))
        throw new Error("Called debounce without a valid number");

    // conversion through any necessary as it wont satisfy criteria otherwise
    return <any>function(this: any, ...args: any[]) {
        clearTimeout(timeoutID);

        timeoutID = window.setTimeout(() => {
            func.apply(this, args);
        }, wait);
    };
};